export default __webpack_public_path__ + "static/media/computer.f8f818ea.png";